<template>
    <div class="">
        <div class="fixed bg-gray-500 opacity-50 h-screen w-screen top-0 left-0 right-0 z-10"></div>
        <div class="fixed top-0 left-0 right-0 w-full h-full flex items-center justify-center z-20">
            <div class="relative flex flex-col justify-between bg-white z-50 max-h-[95vh] w-[25vw] rounded-lg py-12 px-16 overflow-y-scroll no-scrollbar">
                <svg @click="closeWindow" class="w-8 h-8 absolute top-[10px] right-[12px] text-gray-500 cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                <div>
                    <p class="text-2xl mb-8">Выгрузка данных</p>
                    <div class="flex flex-col items-stretch gap-4 mb-8">
                        <StaffSelection v-if="hasAccessToPrintSalaryReportsOfAllStaffs" ref="staffSelectionInput" v-model:selectParam="staff" :options="staffs" labelContent="Сотрудник"/>
                        <div class="flex items-end gap-4 w-full">
                            <MonthSelect ref="periodFromMonthSelectionInput" v-model:selectParam="periodFromMonth" :maxValue="periodToMonth" labelContent="С периода" class="w-full"/>
                            <YearSelect ref="periodFromYearSelectionInput" v-model:selectParam="periodFromYear" labelContent="" class="w-full"/>
                        </div>
                        <div class="flex items-end gap-4 w-full">
                            <MonthSelect ref="periodToMonthSelectionInput" v-model:selectParam="periodToMonth" :minValue="periodFromMonth" labelContent="До периода" class="w-full"/>
                            <YearSelect ref="periodToYearSelectionInput" v-model:selectParam="periodToYear" labelContent="" class="w-full"/>
                        </div>
                        <div class="pt-2">
                            <CheckboxInput v-model:checkboxParam="addSignFormParam" labelContent="Добавить форму подписи"/>
                        </div>
                    </div>
                </div>
                <button @click.stop="downloadPrintScheduleAndSalary" ref="createPayoutButton" :disabled="false" type="button" class="text-center bg-custom-blue hover:bg-custom-blue-hover flex items-center justify-center text-white font-medium rounded-lg text-sm px-5 py-2">Выгрузить</button>
            </div>
        </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';

    import StaffSelection from '@/components/InputComponents/StaffSelection.vue';
    import MonthSelect from '@/components/InputComponents/MonthSelect.vue';
    import YearSelect from '@/components/InputComponents/YearSelect.vue';
    import CheckboxInput from '@/components/InputComponents/CheckboxInput.vue';

    export default {
        name: "PrintScheduleAndSalaryWindow",
        components: {
            StaffSelection,
            MonthSelect,
            YearSelect,
            CheckboxInput,
        },
        props: {
            isOpened: {
                type: Boolean,
                required: true,
            },
            addSignForm: {
                type: Boolean,
                required: true,
            }
        },
        computed: {
            ...mapState(["role", "personalStaffData", "staffs"]),
            hasAccessToPrintSalaryReportsOfAllStaffs() {
                return this.role === "founder" || this.personalStaffData.add_payout_permission;
            },
        },  
        data() {
            return {
                staff: null,
                periodFromMonth: "",
                periodFromYear: "",
                periodToMonth: "",
                periodToYear: "",
                addSignFormParam: null,
            }
        },
        methods: {
            async downloadPrintScheduleAndSalary() {
                if (!this.validateData()) return;
                const payload = {
                    staff: this.staff?.id,
                    dateFrom: `${this.periodFromYear}-${this.periodFromMonth}-01`,
                    dateTo: `${this.periodToYear}-${this.periodToMonth}-01`,
                }
                const result = await this.$store.dispatch("fetchSalaryReportsToPrint", payload);
                if (result.successfully) {
                    this.closeWindow();
                    this.$emit("update:addSignForm", this.addSignFormParam);
                    this.$emit("next");
                }
            },
            validateData() {
                if (!this.staff && this.$refs.staffSelectionInput) {
                    this.$refs.staffSelectionInput.selectionIsOpened = true;
                    return false;
                }
                if (!this.periodFromMonth) {
                    this.$refs.periodFromMonthSelectionInput.selectionIsOpened = true;
                    return false;
                }
                if (!this.periodFromYear) {
                    this.$refs.periodFromYearSelectionInput.selectionIsOpened = true;
                    return false;
                }
                if (!this.periodToMonth) {
                    this.$refs.periodToMonthSelectionInput.selectionIsOpened = true;
                    return false;
                }
                if (!this.periodToYear) {
                    this.$refs.periodToYearSelectionInput.selectionIsOpened = true;
                    return false;
                }
                return true;
            },
            closeWindow() {
                document.body.classList.remove("overflow-hidden");
                this.$emit("update:isOpened", false);
            },
            initData() {
                const firstDayOfCurrentMonth = this.$globalMethods.getFirstDayOfCurrentMonth();
                this.periodFromMonth = firstDayOfCurrentMonth.split("-")[1];
                this.periodFromYear = firstDayOfCurrentMonth.split("-")[0];
                this.periodToMonth = firstDayOfCurrentMonth.split("-")[1];
                this.periodToYear = firstDayOfCurrentMonth.split("-")[0];
                this.addSignFormParam = this.addSignForm;
            }
        },
        created() {
            this.initData();
        }
    }
</script>